import React from 'react';
import {Stack} from '../../components';
import {StatusTag} from '../../components/StatusTag';
import {colors} from '../../lib/colors';
import {checkAffiliateInformationVerified} from './utils/utils';
import {SectionProps} from './utils/types';
import {PROCESSING_AFFILIATE_GROUP_ID} from 'routes/Affiliates/Affiliates';

export const AffiliateStatusTags: React.FC<SectionProps> = ({affiliate, payoutMethod}) => {
  if (!affiliate) return null;

  const verification = checkAffiliateInformationVerified(affiliate, payoutMethod!);
  const isVerified = verification.isValid;
  const isActive = affiliate.affiliate_group_id === PROCESSING_AFFILIATE_GROUP_ID;
  return (
    <Stack gutter={12}>
      {isActive && isVerified && <StatusTag color={colors.success}>Active</StatusTag>}
      {(!isActive || !isVerified) && <StatusTag color={colors.error}>Payouts disabled</StatusTag>}
    </Stack>
  );
};
